import { createContext, Dispatch, FC, useReducer } from 'react';
import { SearchContextActions, SearchContextsTypes } from 'pages/Search/View/Main/types';
import { reducer } from 'pages/Search/View/Main/reducer';

const State: SearchContextsTypes = {
  minBust: '',
  maxBust: '',
  minHeight: '',
  maxHeight: '',
  minBirthday: '',
  maxBirthday: '',
  keyword: '',
  busts: ['', '70', '80', '90'],
  heights: ['', '130', '140', '150'],
  actress: []
};

export const dispatch = () => null;

export const SearchContexts = createContext<{
  state: SearchContextsTypes;
  dispatch: Dispatch<SearchContextActions>;
}>({
  state: State,
  dispatch,
});

const Provider: FC = (props) => {
  const [state, dispatch] = useReducer(reducer, State);
  return <SearchContexts.Provider value={{ state, dispatch }}>{props.children}</SearchContexts.Provider>;
};

export default Provider;
